const OfficeHoursMonitoring = {
    Disabled: 0,
    DuringOfficeHours: 1,
    AfterOfficeHours: 2
};
export default OfficeHoursMonitoring;
